import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNumberslist = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M6.75 5.064a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 0 1.5H7.5a.75.75 0 0 1-.75-.75m0 5.073a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 0 1.5H7.5a.75.75 0 0 1-.75-.75m0 5.073a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 0 1.5H7.5a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
    <path d="M3.59 8.206V4.798l.234.312-.99.498-.204-.78 1.146-.588h.702v3.966zm-.87.294v-.81h2.55v.81zM2.648 16l-.21-.54 1.284-1.23q.15-.144.306-.3.162-.156.294-.318.138-.162.216-.312a.6.6 0 0 0 .084-.294q0-.15-.066-.258a.37.37 0 0 0-.192-.162.86.86 0 0 0-.672.018 1.1 1.1 0 0 0-.336.228q-.156.15-.288.39l-.666-.396q.168-.324.42-.57a1.85 1.85 0 0 1 1.32-.54q.408 0 .72.156.312.15.48.414.174.264.174.612 0 .18-.06.354a1.7 1.7 0 0 1-.156.348 2.6 2.6 0 0 1-.246.336 7 7 0 0 1-.3.342 9 9 0 0 1-.342.336l-1.044.99-.066-.414H5.69V16z" />
  </svg>
);
export default SvgNumberslist;
